<template>
    <b-modal id="editModal" ref="modal" title="Edit Crop Type" v-model="show" @ok="handleSubmit" @hide="close" @shown="focusNameInput">

        <div class="form-group">
            <label>Crop Type Name</label>
            <div class="position-relative">
                <input type="text" ref="nameInput" name="name" v-validate="{required: true}" class="form-control" v-model="name">
                <div class="invalid-feedback" v-if="errors.has('name')">{{ errors.first('name') }}</div>
                <i class="form-group__bar"></i>
            </div>
        </div>

        <template slot="modal-footer">
            <button class="btn btn-link text-danger mr-auto" @click="handleDelete" v-if="!cropType.deleted_at">
                Disable
            </button>
            <button class="btn btn-link text-danger mr-auto" @click="handleRestore" v-if="cropType.deleted_at">
                Restore
            </button>
            <button class="btn btn-secondary" @click="close">
                Cancel
            </button>
            <button class="btn btn-primary" :disabled="okDisabled" @click="handleSubmit">
                Save
            </button>
        </template>
    </b-modal>
</template>


<script>
import deleteCropTypeMutation from '@views/CropTypes/EditModal/mutationDeleteCropType.graphql';
import restoreCropTypeMutation from '@views/CropTypes/EditModal/mutationRestoreCropType.graphql';
import updateCropTypeMutation from '@views/CropTypes/EditModal/mutationUpdateCropType.graphql';

export default {
  name: 'edit-modal',
  apollo: {},
  props: {
    cropType: {
      type: Object,
      required: true,
    },
    close: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      name: this.cropType.name,
      show: true,
      loading: 0,
    };
  },
  computed: {
    okDisabled() {
      return this.name.length === 0;
    },
  },
  methods: {
    handleSubmit() {
      if (this.okDisabled) {
        return false;
      }
      this.errors.remove('global');
      this.$validator.validateAll().then(validationWasSuccessful => {
        if (!validationWasSuccessful) {
          return;
        }

        this.$apollo
          .mutate({
            mutation: updateCropTypeMutation,
            variables: {
              input: {
                id: this.cropType.id,
                name: this.name,
              },
            },
            optimisticResponse: {
              __typename: 'Mutation',
              updateCropType: {
                ...this.cropType,
                name: this.name,
              },
            },
          })
          .then(() => {
            this.$notifySuccess('Crop type updated!');
            this.close();
          })
          .catch(err => {
            this.$mapGraphQLError(err);
          })
          .catch(err => {
            console.error(err);
            this.$notifyFailure(
              'Unfortunately, we were unable to do that!',
            );
          });
      });
    },
    handleDelete() {
      this.$apollo
        .mutate({
          mutation: deleteCropTypeMutation,
          variables: {
            input: {
              id: this.cropType.id,
            },
          },
        })
        .then(() => {
          this.$notifySuccess('Crop type disabled!');
          this.close();
        })
        .catch(err => {
          this.$mapGraphQLError(err);
        })
        .catch(err => {
          console.error(err);
          this.$notifyFailure(
            'Unfortunately, we were unable to do that!',
          );
        });
    },
    handleRestore() {
      this.$apollo
        .mutate({
          mutation: restoreCropTypeMutation,
          variables: {
            input: {
              id: this.cropType.id,
            },
          },
          optimisticResponse: {
            __typename: 'Mutation',
            restoreCropType: {
              ...this.cropType,
              deleted_at: null,
            },
          },
        })
        .then(() => {
          this.$notifySuccess('Crop type restored!');
          this.close();
        })
        .catch(err => {
          this.$mapGraphQLError(err);
        })
        .catch(err => {
          console.error(err);
          this.$notifyFailure(
            'Unfortunately, we were unable to do that!',
          );
        });
    },
    focusNameInput() {
      this.$refs.nameInput.focus();
    },
  },
};
</script>
